import { render, staticRenderFns } from "./jf-post.vue?vue&type=template&id=7c4320f3&scoped=true&"
import script from "./jf-post.vue?vue&type=script&lang=js&"
export * from "./jf-post.vue?vue&type=script&lang=js&"
import style0 from "./jf-post.vue?vue&type=style&index=0&id=7c4320f3&prod&lang=scss&scoped=true&"
import style1 from "./jf-post.vue?vue&type=style&index=1&id=7c4320f3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4320f3",
  null
  
)

export default component.exports